module.exports = __webpack_public_path__ + "static/media/hardy-rolling-hill.5053a894.svg";